<template>
  <div
    class="-simple-tree">
    <jqx-tree
      v-show="initialized"
      ref="tree"
      :dataset="dataset"
      :animationShowDuration="0"
      :animationHideDuration="0"
      :allowDrag="false"
      :allowDrop="false"
      :width="width"
      :height="height"
      @checkChange="oncheckChange"
      @collapse="oncollapse"
      @expand="onexpand"
      @itemClick="onitemClick"
      @select="onselect"
      @initialized="oninitialized"
    />
  </div>
</template>

<script>

import JqxTree from './SuiJqxTree';

export default {
  name: 'SuiSimpleTree',
  components: {
    'jqx-tree': JqxTree,
  },
  props: {
    width: {
      type: [Number, String],
      default: '100%',
    },
    height: {
      type: [Number, String],
      default: '100%',
    },
    source: [Array, Object],
    dataset: [String],
  },
  data() {
    return {
      initialized: false,
    };
  },
  mounted() {
  },
  beforeDestroy() {
    this.$refs.tree.destroy();
  },
  methods: {
    setSource(source) {
      this.$refs.tree.source = source;
      this.initialized = true;
    },
    reveal(id) {
      const item = this.getItemById(id);
      const instance = this.$refs.tree.getInstance();
      if (item && instance) {
        instance.selectItem(item);
        instance.expandItem(item);
        instance.ensureVisible(item.element);
      }
    },
    getItemById(id) {
      const items = this.getItems();
      let item = null;
      utils.forEach(items, row => { 
        if (row.id === id) {
          item = row;
        }
      });
      return item;
    },
    selectItemById(id) {
      const items = this.getItems();
      let item = null;
      for (let i = 0; i < items.length; i += 1) {
        if (items[i].id === id) {
          item = items[i];
          break;
        }
      }
      if (item) {
        this.selectItem(item);
      }
      return item;
    },
    render() {
      this.$refs.tree.render();
    },
    refresh() {
      this.$refs.tree.refresh();
    },
    clear() {
      this.$refs.tree.clear();
    },
    checkAll() {
      this.$refs.tree.checkAll();
    },
    checkItem(item) {
      this.$refs.tree.checkItem(item);
    },
    collapseAll() {
      this.$refs.tree.collapseAll();
    },
    collapseItem(item) {
      this.$refs.tree.collapseItem(item);
    },
    destroy() {
      this.$refs.tree.destroy();
    },
    ensureVisible(item) {
      this.$refs.tree.ensureVisible(item);
    },
    expandAll() {
      this.$refs.tree.expandAll();
    },
    expandItem(item) {
      this.$refs.tree.expandItem(item);
    },
    getCheckedItems() {
      return this.$refs.tree.getCheckedItems();
    },
    getUncheckedItems() {
      return this.$refs.tree.getUncheckedItems();
    },
    getItems() {
      return this.$refs.tree.getItems();
    },
    getItem(element) {
      return this.$refs.tree.getItem(element);
    },
    getSelectedItem() {
      return this.$refs.tree.getSelectedItem();
    },
    selectItem(element) {
      this.$refs.tree.selectItem(element);
    },
    uncheckAll() {
      this.$refs.tree.uncheckAll();
    },
    uncheckItem(element) {
      this.$refs.tree.uncheckItem(element);
    },
    oncheckChange(e) {
      this.$emit('checkChange', e);
    },
    oncollapse(e) {
      this.$emit('collapse', e);
    },
    onexpand(e) {
      this.$emit('expand', e);
    },
    onitemClick(e) {
      this.$emit('itemClick', e);
    },
    onselect(e) {
      this.$emit('select', e);
    },
    oninitialized(e) {
      this.initialized = true;
      this.$emit('initialized', e);
    },
  },
};
</script>

<style scoped>
</style>
